












import {Component, Prop, Vue} from "vue-property-decorator";
import WeeklyCalendar from "../components/WeeklyCalendar.vue";
import TopNav from "../components/TopNav.vue";
import AdminNav from "../components/AdminNav.vue";
import {verifyAuth} from "../session";

@Component({
    components: {WeeklyCalendar, TopNav, AdminNav},
})
export default class Calendar extends Vue {
    public created() {
        verifyAuth();
    }
}
